import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormEightAData } from "../../../types/LegalAdvices/LegalAdviceFormEightA.type";
// import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
// import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormEightAData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormEightADocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
  renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
//  const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
// const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
    <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black space-y-14 text-xs md:text-sm leading-relaxed">
        
        {/* ခေါင်းစီးပိုင်း */}
        <div>
          <div className="text-right text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၈-က)</div>
          
          <div className="text-center space-y-2 mt-2">
            <h1 className="text-base font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
            <h2 className="text-sm font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
            <h2 className="text-sm font-bold">နေပြည်တော်</h2>
            
            <h3 className="text-sm font-bold pt-4 max-w-xl mx-auto leading-normal">
              အပြီးအပြတ်လွှတ်သည့်အမိန့်ကို အယူခံဝင်ရန် သင့် မသင့် <br />
              ပြည်ထောင်စုရှေ့နေချုပ်ရုံးက စိစစ်ခြင်း
            </h3>
          </div>

          {/* အပိုင်း ၁။ စိစစ်ချက်အချက်အလက်များ (၁ မှ ၉) */}
          <div className="mt-8 space-y-4">
            <div className="flex items-baseline">
              <span className="w-10 font-bold">၁။</span>
              <span className="flex-1">စိစစ်သည့် အမှုတွဲအမှတ်</span>
              <input type="text" name="scrutinyCaseNo" value={formData.scrutinyCaseNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၂။</span>
              <span className="flex-1">အယူခံဝင်ရန်သင့် မသင့် စိစစ်ခြင်းမှတ်ပုံတင်အမှတ်စဉ်</span>
              <input type="text" name="appealRegisterNo" value={formData.appealRegisterNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၃။</span>
              <span className="flex-1">တင်ပြသည့် တိုင်းဒေသကြီး/ ပြည်နယ်ဥပဒေချုပ်ရုံးအမည်</span>
              <input type="text" name="submittingOfficeName" value={formData.submittingOfficeName} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၄။</span>
              <span className="flex-1">တရားလွှတ်တော်အမည်၊ အမှုအမှတ်၊ အမိန့်၊ ရက်စွဲ</span>
              <input type="text" name="highCourtDetails" value={formData.highCourtDetails} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၅။</span>
              <span className="flex-1">မူလရုံး အမှုအမှတ်၊ တရားစွဲဆိုသည့်ဥပဒေ ပုဒ်မ</span>
              <input type="text" name="originalCourtDetails" value={formData.originalCourtDetails} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၆။</span>
              <span className="flex-1">စွဲချက်တင်သည့် ဥပဒေ ၊ ပုဒ်မ</span>
              <input type="text" name="chargedSection" value={formData.chargedSection} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၇။</span>
              <span className="flex-1">မူလရုံးအမိန့်၊ ရက်စွဲ</span>
              <div className="flex-grow">{renderDatePicker('originalJudgmentDate')}</div>
              {/* <input type="text" name="originalJudgmentDate" value={formData.originalJudgmentDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" /> */}
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၈။</span>
              <span className="flex-1">အယူခံ၊ ပြင်ဆင်ရုံး၏ အမှုအမှတ်၊ အမိန့်၊ ရက်စွဲ</span>
              <input type="text" name="appealCourtDetails" value={formData.appealCourtDetails} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>

            <div className="flex items-baseline">
              <span className="w-10 font-bold">၉။</span>
              <span className="flex-1">အယူခံဝင်ရန် ကာလစည်းကမ်းသတ် ကုန်ဆုံးသည့်ရက်စွဲ</span>
              <div className="flex-grow">{renderDatePicker('appealDeadlineDate')}</div>
              <input type="text" name="appealDeadlineDate" value={formData.appealDeadlineDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
            </div>
          </div>
        </div>
{/* 
        <hr className="border-gray-300" /> */}

        {/* အပိုင်း ၂။ ကနဦး စိစစ်သည့် ဥပဒေအရာရှိ၏ သုံးသပ်ချက် (၁၀) */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold"><span className="mr-4">၁၀။</span>ကနဦး စိစစ်သည့် ဥပဒေအရာရှိ၏ သုံးသပ်တင်ပြချက်</label>
            <div className="pl-6 space-y-3 mt-2">
              <div className="flex flex-col space-y-1">
                <span className="font-medium">(က) တရားလိုဘက်မှ တင်ပြချက်များ အပေါ် သုံးသပ်ချက်</span>
                <textarea name="initialOfficerOpinionProsecution" value={formData.initialOfficerOpinionProsecution} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
              </div>
              <div className="flex flex-col space-y-1">
                <span className="font-medium">(ခ) တရားခံဘက်မှ တင်ပြချက်များ အပေါ် သုံးသပ်ချက်</span>
                <textarea name="initialOfficerOpinionDefense" value={formData.initialOfficerOpinionDefense} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
              </div>
              <div className="flex flex-col space-y-1">
                <span className="font-medium">(ဂ) နှစ်ဖက်တင်ပြချက်များ နှင့်စပ်လျဉ်း၍ အယူခံဝင် သင့် မသင့် သုံးသပ်တင်ပြချက်</span>
                <textarea name="jointOfficerOpinionFitness" value={formData.jointOfficerOpinionFitness} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
              </div>
            </div>
          </div>

          {/* ကနဦးစိစစ်သူ လက်မှတ်ကွက် */}
          <div className="flex flex-col items-end pt-4">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div 
                //onClick={() => handleOpenSignatureModal('initial')} 
                className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                  {formData.initialOfficerSignatureImage ? (
                    <img src={formData.initialOfficerSignatureImage} alt="Initial Officer Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                  {formData.initialOfficerSignatureImage && (
                    <button
                      type="button"
                      //onClick={handleClearInitialSignature}
                      title="လက်မှတ်ရှင်းလင်းမည်"
                      className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="initialOfficerSignName" value={formData.initialOfficerSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">ရာထူး</span>
                <input type="text" name="initialOfficerRank" value={formData.initialOfficerRank} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('initialOfficerReceiveDate')}</div>
                {/* <input type="text" name="initialOfficerReceiveDate" value={formData.initialOfficerReceiveDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('initialOfficerSubmitDate')}</div>
                {/* <input type="text" name="initialOfficerSubmitDate" value={formData.initialOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />

        {/* ညွှန်ကြားရေးမှူး၏ သဘောထားမှတ်ချက် */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold">ညွှန်ကြားရေးမှူး၏ သဘောထားမှတ်ချက်</label>
            <textarea name="directorOpinion" value={formData.directorOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
          </div>

          <div className="flex flex-col items-end pt-2">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div 
                //onClick={() => handleOpenSignatureModal('director')} 
                className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                  {formData.directorSignatureImage ? (
                    <img src={formData.directorSignatureImage} alt="Director Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                  {formData.directorSignatureImage && (
                    <button
                      type="button"
                     // onClick={handleClearDirectorSignature}
                      title="လက်မှတ်ရှင်းလင်းမည်"
                      className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="directorSignName" value={formData.directorSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">ညွှန်ကြားရေးမှူး</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('directorReceiveDate')}</div>
                {/* <input type="text" name="directorReceiveDate" value={formData.directorReceiveDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('directorSubmitDate')}</div>
                {/* <input type="text" name="directorSubmitDate" value={formData.directorSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />

        {/* ဒုတိယညွှန်ကြားရေးမှူးချုပ်၏ သဘောထားမှတ်ချက် */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold">ဒုတိယညွှန်ကြားရေးမှူးချုပ်၏ သဘောထားမှတ်ချက်</label>
            <textarea name="deputyDirectorGeneralOpinion" value={formData.deputyDirectorGeneralOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
          </div>

          <div className="flex flex-col items-end pt-2">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div 
                //onClick={() => handleOpenSignatureModal('deputyDG')} 
                className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                  {formData.deputyDirectorGeneralSignatureImage ? (
                    <img src={formData.deputyDirectorGeneralSignatureImage} alt="Deputy DG Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                  {formData.deputyDirectorGeneralSignatureImage && (
                    <button
                      type="button"
                     // onClick={handleClearDeputySignature}
                      title="လက်မှတ်ရှင်းလင်းမည်"
                      className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="deputyDirectorGeneralSignName" value={formData.deputyDirectorGeneralSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">ဒုတိယညွှန်ကြားရေးမှူးချုပ်</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('deputyDirectorGeneralReceiveDate')}</div>
                {/* <input type="text" name="deputyDirectorGeneralReceiveDate" value={formData.deputyDirectorGeneralReceiveDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('deputyDirectorGeneralSubmitDate')}</div>
                {/* <input type="text" name="deputyDirectorGeneralSubmitDate" value={formData.deputyDirectorGeneralSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />

        {/* ညွှန်ကြားရေးမှူးချုပ်၏ သဘောထားမှတ်ချက် */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold">ညွှန်ကြားရေးမှူးချုပ်၏ သဘောထားမှတ်ချက်</label>
            <textarea
              name="directorGeneralOpinion"
              value={formData.directorGeneralOpinion}
              onChange={handleChange}
              rows={4}
              className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none"
            />
          </div>

          <div className="flex flex-col items-end pt-2">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center relative">
                  {formData.directorGeneralSignatureImage ? (
                    <img src={formData.directorGeneralSignatureImage} alt="Director General Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="directorGeneralSignName" value={formData.directorGeneralSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">ညွှန်ကြားရေးမှူးချုပ်</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('directorGeneralReceiveDate')}</div>
              </div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('directorGeneralSubmitDate')}</div>
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />

        {/* ဒုတိယရှေ့နေချုပ်၏ ဆုံးဖြတ်ချက် */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold">ဒုတိယရှေ့နေချုပ်၏ အယူခံဝင်ရန် သင့် မသင့် ဆုံးဖြတ်ချက်</label>
            <textarea
              name="deputyAttorneyGeneralOpinion"
              value={formData.deputyAttorneyGeneralOpinion}
              onChange={handleChange}
              rows={4}
              className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none"
            />
          </div>

          <div className="flex flex-col items-end pt-2">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center relative">
                  {formData.deputyAttorneyGeneralSignatureImage ? (
                    <img src={formData.deputyAttorneyGeneralSignatureImage} alt="Deputy Attorney General Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="deputyAttorneyGeneralSignName" value={formData.deputyAttorneyGeneralSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">ဒုတိယရှေ့နေချုပ်</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">ဆုံးဖြတ်သည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('deputyAttorneyGeneralSubmitDate')}</div>
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />

        {/* ပြည်ထောင်စုရှေ့နေချုပ်၏ ဆုံးဖြတ်ချက် */}
        <div className="space-y-4">
          <div className="flex flex-col space-y-1">
            <label className="font-bold">ပြည်ထောင်စုရှေ့နေချုပ်၏ ဆုံးဖြတ်ချက်</label>
            <textarea
              name="unionAttorneyGeneralOpinion"
              value={formData.unionAttorneyGeneralOpinion}
              onChange={handleChange}
              rows={4}
              className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none"
            />
          </div>

          <div className="flex flex-col items-end pt-2">
            <div className="w-80 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center relative">
                  {formData.unionAttorneyGeneralSignatureImage ? (
                    <img src={formData.unionAttorneyGeneralSignatureImage} alt="Union Attorney General Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="unionAttorneyGeneralSignName" value={formData.unionAttorneyGeneralSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">ပြည်ထောင်စုရှေ့နေချုပ်</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">ဆုံးဖြတ်သည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('unionAttorneyGeneralSubmitDate')}</div>
              </div>
            </div>
          </div>
        </div>


      </div>
  );
};